// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable no-param-reassign */
import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import module2columns from '@tcp/core/src/components/common/molecules/HelpCenterModuleTwoColNew';
import accordion from '@tcp/core/src/components/common/molecules/AccordionModule';
import moduleX from '@tcp/core/src/components/common/molecules/ModuleX';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import PageSlots from '@tcp/core/src/components/common/molecules/PageSlots';
import SeoCopy from '@tcp/core/src/components/features/browse/ProductListing/molecules/SeoCopy/views';
import { LIVECHAT_SESSION_KEYS } from '@tcp/core/src/components/features/account/CustomerHelp/CustomerHelp.constants';
import { setSessionStorage, removeSessionStorage } from '@tcp/core/src/utils';
import styles from '../styles/HelpCenterNew.style';
import HELPCENTER_CONSTANTS from '../HelpCenterNew.constants';

const modules = { module2columns, accordion, moduleX };

const HelpCenterDynamicRender = (slotData) => {
  const { slots, setResStatusNotFound, allModules } = slotData;
  if ((!slots || !slots.length) && setResStatusNotFound) {
    setResStatusNotFound();
  }

  const rest = slots.filter(
    (slot) =>
      slot.moduleName !== 'placeholder' &&
      slot.moduleName !== 'module_container' &&
      slot.moduleName !== 'accordion'
  );
  return (
    <>
      <PageSlots
        modules={modules}
        allModules={allModules}
        {...slotData}
        helpCenterSlots={slots}
        slots={rest}
      />
    </>
  );
};

const HelpCenterView = (props) => {
  const { className, seoData, selectedPage, l3pageName, pageName, userEmail } = props;
  const isHelpCenterHomePage = selectedPage === HELPCENTER_CONSTANTS.HELP_CENTER_ROUTES.HOME;
  const isHelpCenterL2Page = !isHelpCenterHomePage && !l3pageName;
  const isHelpCenterL3Page = !isHelpCenterHomePage && l3pageName.length > 0;

  const handleModule2ColStyle = () => {
    const moduleTwoCols = document?.querySelectorAll(
      '.helpcenter__view .helpCenterModuleTwoCol'
    )?.[0];
    const accordian = document?.querySelectorAll('.showonlyInMobile')?.[0];
    if ((isHelpCenterL2Page || l3pageName) && accordian && !isHelpCenterHomePage) {
      if (moduleTwoCols) moduleTwoCols.style.marginTop = '0px';
      if (accordian) accordian.style.top = '200px';
    } else if (isHelpCenterHomePage) {
      if (moduleTwoCols) moduleTwoCols.style.marginTop = '142px';
      if (accordian) accordian.style.top = '152px';
    }
  };
  const handleHelpCenterStyle = () => {
    handleModule2ColStyle();
    const styledColumns = document?.querySelectorAll('.helpcenter__view .styled-column');
    if (!styledColumns) return;
    styledColumns.forEach((col) => {
      let heading = col.querySelector('.help_center_heading_border');
      if (!heading) {
        heading = col.querySelector('.help_center_heading');
      }
      if (heading && window) {
        const computeStyleOfHeading = window.getComputedStyle(heading);
        const paddBottom = parseInt(computeStyleOfHeading.paddingBottom.split('px')[0], 10) || 11;
        col.style.paddingTop = `${
          parseInt(computeStyleOfHeading.height.split('px')[0], 10) +
          parseInt(computeStyleOfHeading.marginBottom.split('px')[0], 10) +
          2 * paddBottom
        }px`;
      }
    });
  };

  const launchBotFromHelpCenter = () => {
    const { INITIATE_LIVE_CHAT, EMAIL_ADDRESS } = LIVECHAT_SESSION_KEYS;

    removeSessionStorage(EMAIL_ADDRESS);
    removeSessionStorage(INITIATE_LIVE_CHAT);
    setSessionStorage({ key: INITIATE_LIVE_CHAT, value: true });
    setSessionStorage({ key: EMAIL_ADDRESS, value: userEmail });
    window.launchBot();
  };

  useEffect(() => {
    if (window) window.launchBotFromHelpCenter = launchBotFromHelpCenter;
    return () => {
      if (window) window.launchBotFromHelpCenter = null;
    };
  }, []);

  return (
    <div className={`${className} helpcenter__view`}>
      <HelpCenterDynamicRender
        {...props}
        handleHelpCenterStyle={handleHelpCenterStyle}
        isHelpCenterHomePage={isHelpCenterHomePage}
        isHelpCenterL2Page={isHelpCenterL2Page}
        isHelpCenterL3Page={isHelpCenterL3Page}
        pageName={pageName}
        l3pageName={l3pageName}
      />
      <SeoCopy {...seoData} />
    </div>
  );
};

HelpCenterView.propTypes = {
  slotData: PropTypes.shape({}),
  className: PropTypes.string.isRequired,
  seoData: PropTypes.shape({}),
  selectedPage: PropTypes.string,
  pageName: PropTypes.string,
  l3pageName: PropTypes.string,
};

HelpCenterView.defaultProps = {
  slotData: {},
  seoData: {},
  selectedPage: '',
  pageName: '',
  l3pageName: '',
};

export default withStyles(errorBoundary(HelpCenterView), styles);
export { HelpCenterView as HelpCenterViewVanilla };
